/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var app = {} || app;
app.settings = {};
app.settings.NAVAFFIX = 110;
app.settings.isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (app.settings.isMobile.Android() || app.settings.isMobile.BlackBerry() || app.settings.isMobile.iOS() || app.settings.isMobile.Opera() || app.settings.isMobile.Windows());
  }
};


(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    hammertime: null,
    // All pages
    'common': {
      init: function () {

        var hash = window.location.hash.split('#')[1];

        if (hash !== undefined) {
          if (hash.indexOf('tab-') !== -1) {
            $('#' + hash + ' a').tab('show');
          }
        }


        $('.navbar-toggle').click(function () {
          $('.mobile-bg-nav').addClass('open');
        });

        $('.trigger-videopopin').click(function () {
          $('.videopopin').addClass('open');
          window.player.playVideo();
        });

        $('.videopopin .bg').on('click', function () {
          $('.trigger-close-video-popin').trigger('click');
        });

        $('.trigger-close-video-popin').on('click', function () {
          $(this).parent().removeClass('open');
          window.player.stopVideo();
        }); 

        if (!app.settings.isMobile.any()) {
          $('#menu-menu-principal-blog .dropdown>a').on('mouseenter', function (e) {
            $(this).parent('.dropdown').addClass("open");
          });
          $('#menu-menu-principal-blog .dropdown').on('mouseleave', function (e) {
            $(this).removeClass("open");
          });

          $('#menu-menu-principal .dropdown>a').on('mouseenter', function (e) {
            $(this).parent('.dropdown').addClass("open");
          });
          $('#menu-menu-principal .dropdown').on('mouseleave', function (e) {
            $(this).removeClass("open");
          });

          // $('#menu-menu-principal .dropdown').on('mouseleave', function () {
          //   $(this).removeClass("open");
          // }).on('mouseenter', function () {
          //   $(this).addClass("open");
          // });
        }
        $('#menu-menu-principal-blog .dropdown .mobile-open').on('click', function (e) {
          $(this).parent('.dropdown').toggleClass("open");
          e.stopPropagation();
          return false;
        });
        $('#menu-menu-principal .dropdown .mobile-open').on('click', function (e) {
          $(this).parent('.dropdown').toggleClass("open");
          e.stopPropagation();
          return false;
        });


        $('.trigger-close-nav').on('click', function () {
          $('.navbar-collapse').collapse('hide');
          $('.mobile-bg-nav').removeClass('open');
        });


        $('.trigger-anchor').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href');
          if (id === '') {
            $('html, body').animate({scrollTop: 0}, 800);
          } else {
            $('html, body').animate({scrollTop: $(id).offset().top - 140}, 800);
            if (id.indexOf('tab-') !== -1) {
              $(id + ' a').tab('show');
            }
          }
        });


        
        // ###########################################################################################
        // WINDOW SCROLL 
        // ########################################################################################### 
        
        $(window).on('scroll', function (e) {
          
          if ($('#bouton_sticky').html()) {
            Sage.common.stickyPosition();
          }

          // Bandeau Cookies
          var scrollTop = $(window).scrollTop();
          if (scrollTop != 0) {
            // Cache le bandeau cookie
            $('#cookie-law-info-bar').fadeOut();
            // Change la position top du header quand on scroll car il diminue en hauteur
            Sage.common.setTopHeaderOnHideCookie();    
          }

          // Affiche le sticky sur les pages article
          var sectionNewsletterHeight = $('.section-newsletter').innerHeight();
          var footerHeight = $('footer').innerHeight();
          var singlePostHeight = $('.single-post').innerHeight();
          var diffHeight = singlePostHeight - sectionNewsletterHeight - footerHeight;
          var windowScroll = $(window).scrollTop();
          var newsletterPosTop = $('.section-newsletter').offset().top;

          if(windowScroll > newsletterPosTop - 600) $('.article-sticky').fadeOut('slow');
          if(windowScroll < newsletterPosTop - 600) $('.article-sticky').fadeIn('slow');
          
        });


        // ###########################################################################################
        // WINDOW RESIZE 
        // ########################################################################################### 
        
        $(window).on('resize', function(){
          // Outside-container
          if ($('body').hasClass('single-post')) {
            Sage.common.setValOutsideContainer();
          }

          Sage.common.setTopHeader();

          Sage.common.setClassSliderMag();

        });


        // ###########################################################################################
        // DOCUMENT READY 
        // ########################################################################################### 
        
        $(document).ready(function () {

          $('.wpcf7-select').addClass("not_chosen");

          // Select placeholder
          if ($('select').length) {
            // Traverse through all dropdowns
            $.each($('select'), function (i, val) {
                var $el = $(val);
                 
                // If there's any dropdown with default option selected
                // give them `not_chosen` class to style appropriately
                // We assume default option to have a value of '' (empty string)
                if (!$el.val()) {
                    $el.addClass("not_chosen");
                }
                 
                // Add change event handler to do the same thing,
                // i.e., adding/removing classes for proper
                // styling. Basically we are emulating placeholder
                // behaviour on select dropdowns.
                $el.on("change", function () {
                    if (!$el.val())
                        $el.addClass("not_chosen");
                    else
                        $el.removeClass("not_chosen");
                });
                 
                // end of each callback
          });
        }




          // Outside-container
          if ($('body').hasClass('single-post')) {
            Sage.common.setValOutsideContainer();
          }                             

          if ($('#bouton_sticky').html()) {
            Sage.common.stickyPosition();
          }

          // Change la position top du header quand il y a le bandeau cookies actif
          Sage.common.setTopHeader();

          // Change header top position when hide cookie
          $('#cookie_action_close_header').click(function () {
            Sage.common.setTopHeaderOnHideCookie();
          });
          
          // Offre e-gerance
          var section1_autoplay = $('#section1_autoplay').val();
          var section1_autoplayspeed = $('#section1_autoplayspeed').val();

          switch(section1_autoplay) {
            case "Oui":
                section1_autoplay = true;
                break;
            case "Non":
                section1_autoplay = false;
                break;
          }

          $(".section1-slider").slick({ 
            arrows: false,
            autoplay: section1_autoplay,
            autoplaySpeed: section1_autoplayspeed,
            dots: true,
            fade: false,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            adaptiveHeight: false
          });

          // Ou en êtes-vous ?
          var section2_autoplay = $('#section2_autoplay').val();
          var section2_autoplayspeed = $('#section2_autoplayspeed').val();

          switch(section2_autoplay) {
            case "Oui":
                section2_autoplay = true;
                break;
            case "Non":
                section2_autoplay = false;
                break;
          }

          $('.section2-slider .slider-numbered').slick({
            centerMode: true,
            dots: true,
            autoplay: section2_autoplay,
            autoplaySpeed: section2_autoplayspeed,
            asNavFor: '.section2-slider .slider-for',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: false
                    }
                }
            ]
          });

          $('.section2-slider .slider-for').slick({
            dots: true,
            asNavFor: '.section2-slider .slider-numbered'
          });

          $(window).bind('orientationchange', function (event) {
              if ($('.section2-slider .slider-numbered').hasClass('slick-slider')) {
                  setTimeout(function () {// permet de re-créer le slider afin d'avoir la bonne width des items (calculé automatiquement par slick)
                      $('.section2-slider .slider-numbered').slick('unslick');
                      $('.section2-slider .slider-for').slick('unslick');
                      setTimeout(function () {
                          $('.section2-slider .slider-numbered').slick({
                              centerMode: true,
                              dots: true,
                              asNavFor: '.section2-slider .slider-for',
                              responsive: [
                                  {
                                      breakpoint: 767,
                                      settings: {
                                          centerMode: false
                                      }
                                  }
                              ]
                          });
                          $('.section2-slider .slider-for').slick({
                              dots: true,
                              asNavFor: '.section2-slider .slider-numbered'
                          });
                      }, 500);
                  }, 200);
              }
          });

          // $('.section2-slider .slider-for').slick({
          //   dots: false,
          //   arrows: false,
          //   centerMode: false,
          //   infinite: true,
          //   slidesToScroll: 1,
          //   slidesToShow: 3,
          //   focusOnSelect: true,
          //   asNavFor: '.section2-slider .slider-numbered',
          // });

          // $('.section2-slider .slider-numbered').slick({
          //   dots: true,
          //   arrows: true,
          //   slidesToScroll: 1,
          //   slidesToShow: 1,
          //   adaptiveHeight: true,
          //   infinite: true,
          //   autoplay: section2_autoplay,
          //   autoplaySpeed: section2_autoplayspeed,
          //   asNavFor: '.section2-slider .slider-for',
          //   centerMode: true,
          //   focusOnSelect: true,
          //   variableWidth: false
          // });

          // Tous nos services
          $(".box-all-services").slick({ 
            arrows: false,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: true,
            fade: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 4,
            adaptiveHeight: false,
            responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 1,
                      centerMode: false
                  }
              }
            ] 
          });

          // Tous nos services
          $(".box-outils-precieux").slick({ 
            arrows: false,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: true,
            fade: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 3,
            adaptiveHeight: false,
            responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 1,
                      centerMode: false
                  }
              }
            ] 
          });

          // Tous nos services
          $(".box-confiance").slick({ 
            arrows: false,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: true,
            fade: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 3,
            adaptiveHeight: false,
            responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 1,
                      centerMode: false
                  }
              }
            ] 
          });

          // Related posts
          if (!$("body").hasClass("mag") && $("body").hasClass("archive") && $("body").hasClass("recherche")) {
              $(".postlist").slick({ 
                arrows: false,
                autoplay: false,
                autoplaySpeed: 3000,
                dots: true,
                fade: false,
                infinite: true,
                slidesToScroll: 3,
                slidesToShow: 3,
                adaptiveHeight: false,
                responsive: [
                  {
                    breakpoint: 1025,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2,
                        centerMode: false
                    }
                  },
                  {
                      breakpoint: 767,
                      settings: {
                          slidesToScroll: 1,
                          slidesToShow: 1,
                          centerMode: false
                      }
                  }
                ] 
              });
          }

          // Services essentiels
          $(".wrapper-slider-services").slick({ 
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            fade: false,
            infinite: true,
            slidesToScroll: 5,
            slidesToShow: 5,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3,
                    centerMode: false
                }
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToScroll: 1,
                      slidesToShow: 1,
                      centerMode: false
                  }
              }
            ] 
          });

          /*
          * Replace all SVG images with inline SVG
          */
          $('.wrapper-slider-services img.svg').each(function(){
            var $img = $(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

          });

          // Mag
          $(".nav-rubriques").slick({ 
            variableWidth: true,
            arrows: false,
            autoplay: false,
            dots: false,
            fade: false,
            infinite: false,
            centerMode: false,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                    centerMode: false
                }
              },
              {
                  breakpoint: 767,
                  settings: {
                      centerMode: false
                  }
              }
            ] 
          });

          // Calcul de la largeur de tous les slides présents et ajoute une classe si cela dépasse du conteneur
          Sage.common.setClassSliderMag();
          

          

          $(".list-articles").slick({ 
            arrows: false,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: true,
            fade: false,
            infinite: false,
            slidesToScroll: 3,
            slidesToShow: 3,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                    centerMode: false
                }
              },
              {
                  breakpoint: 481,
                  settings: {
                      slidesToScroll: 1,
                      slidesToShow: 1,
                      centerMode: false
                  }
              }
            ] 
          });



        }); // END DOCUMENT READY

        // Newsletter
        //var popin_count = 0;
        //document.body.onmouseleave = function() { popin_count = Sage.common.mouseLeave(popin_count) };
        $('.btn-open-newsletter').click(function () {
          Sage.common.toggleNewsletter();
        });
        $('.btn-close-newsletter').click(function () {
          Sage.common.closeNewsletter();
        });
        $('.btn-close-newsletter').click(function () {
          Sage.common.closeNewsletter();
        });
        $('#form-newsletter').submit(function (e) {
          if ($('#optin-newsletter-2').is(":checked")) {
            Sage.common.submitNewsletter();
            e.preventDefault();
            return false;
          }
          else {
            $('#label-optin-newsletter-2').fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
            e.preventDefault();
            return false;
          }
        });
        $('#form-newsletter2').submit(function (e) {
          if ($('#optin-newsletter').is(":checked")) {
            Sage.common.submitNewsletter();
            e.preventDefault();
            return false;
          }
          else {
            $('#label-optin-newsletter').fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
            e.preventDefault();
            return false;
          }
        });

        var article_chapitre = $('#track_article_chapitre').val();

        $('.nc_tweetContainer.swp_fb a.nc_tweet').click(function () {
          return tc_events_1(this, 'CLICK', {
            'label': '' + article_chapitre + '::Partage_Facebook',
            'xtclick_event': 'C',
            'xtclick_s2': '21',
            'xtclick_type': 'S'
          });
        });
        $('.nc_tweetContainer.twitter a.nc_tweet').click(function () {
          return tc_events_1(this, 'CLICK', {
            'label': '' + article_chapitre + '::Partage_Twitter',
            'xtclick_event': 'C',
            'xtclick_s2': '21',
            'xtclick_type': 'S'
          });
        });
        $('.nc_tweetContainer.googlePlus a.nc_tweet').click(function () {
          return tc_events_1(this, 'CLICK', {
            'label': '' + article_chapitre + '::Partage_Google+',
            'xtclick_event': 'C',
            'xtclick_s2': '21',
            'xtclick_type': 'S'
          });
        });
        $('.nc_tweetContainer.linkedIn a.nc_tweet').click(function () {
          return tc_events_1(this, 'CLICK', {
            'label': '' + article_chapitre + '::Partage_LinkedIn',
            'xtclick_event': 'C',
            'xtclick_s2': '21',
            'xtclick_type': 'S'
          });
        });
        $('.nc_tweetContainer.swp_email a.nc_tweet').click(function () {
          return tc_events_1(this, 'CLICK', {
            'label': '' + article_chapitre + '::Partage_mail',
            'xtclick_event': 'C',
            'xtclick_s2': '21',
            'xtclick_type': 'S'
          });
        });
        $('.mag_back_egerance a').click(function () {
          return tc_events_1(this, 'CLICK', {
            'label': 'BLOG::HEADER::E-gerance-site',
            'xtclick_event': 'C',
            'xtclick_s2': '21',
            'xtclick_type': 'S'
          });
        });

        $('.btn-close-newsletter').click(function () {
          Sage.common.closeNewsletter();
        });


        this.phoneControl('input[name="telephone"]');

      },
      submitNewsletter: function () {
        var email = $('#form-newsletter-email').val();
        $('#form-newsletter-loading').fadeIn();
        $("#form-newsletter .form-input").prop('disabled', true);
        $.post(
          ajaxurl,
          {
            'action': 'newsletter_inscription',
            'email': $('#form-newsletter-email').val()
          },
          function (response) {
            $("#form-newsletter .form-input").prop('disabled', false);
            $('.form-newsletter-msg').hide();
            if (response.ok == 1) {
              $("#form-newsletter .form-input").hide();
              $('#form-newsletter-email').val('');
              $('#form-newsletter-ok').fadeIn();
            }
            if (response.error != '') {
              $('#form-newsletter-' + response.error).fadeIn();
            }
          }, "json");

          var email = $('#form-newsletter2-email').val();
        $('#form-newsletter2-loading').fadeIn();
        $("#form-newsletter2 .form-input").prop('disabled', true);
        $.post(
          ajaxurl,
          {
            'action': 'newsletter_inscription',
            'email': $('#form-newsletter2-email').val()
          },
          function (response) {
            $("#form-newsletter2 .form-input").prop('disabled', false);
            $('.form-newsletter2-msg').hide();
            if (response.ok == 1) {
              $("#form-newsletter2 .form-input").hide();
              $('#form-newsletter2-email').val('');
              $('#form-newsletter2-ok').fadeIn();
            }
            if (response.error != '') {
              $('#form-newsletter2-' + response.error).fadeIn();
            }
          }, "json");
      },
      toggleNewsletter: function () {
        var news = $("#popup-newsletter");
        if (news.hasClass('close')) {
          Sage.common.openNewsletter();
        } else {
          Sage.common.closeNewsletter();
        }
      },
      openNewsletter: function () {
        var news = $("#popup-newsletter");
        $("#form-newsletter .form-input").show();
        $("#form-newsletter .alert").hide();
        $("#form-newsletter .form-input").prop('disabled', false);
        // $("#form-newsletter-email").focus();

        $("#form-newsletter2 .form-input").show();
        $("#form-newsletter2 .alert").hide();
        $("#form-newsletter2 .form-input").prop('disabled', false);
        // $("#form-newsletter2-email").focus();
        news.removeClass('close').addClass('open');
      },
      closeNewsletter: function () {
        var news = $("#popup-newsletter");
        news.removeClass('open').addClass('close');
      },
      // mouseLeave: function(popin_count) {
      //   if (popin_count == 0) {
      //     Sage.common.openNewsletter();
      //     popin_count = 1;
      //   }
      //   return popin_count;
      // },
      stickyPosition: function () {

        var $boutonSticky = $('#bouton_sticky');
        var $boutonStickyMobile = $('#bouton_sticky_mobile');
        var $boutonStickyContainer = $('#bouton_sticky_container');
        var $boutonStickyStop = $('#bouton_sticky_stop');

        var $body = $(document);
        var m = 57;

        var gap = app.settings.NAVAFFIX + m;

        var boutonTop = $boutonSticky.offset().top;
        var boutonContainerTop = $boutonStickyContainer.offset().top;
        var stopTop = $boutonStickyStop.offset().top;
        var position = $body.scrollTop();

        if ((position + gap - m) > boutonContainerTop) {
          // console.log('on fixe ' + (position + gap) + ' > ' + boutonContainerTop);

          if (position > (stopTop - (gap + (m / 2)) - $boutonSticky.height())) {
            // On défixe juste avant le stop
            $boutonSticky.removeClass('affix');
            $boutonSticky.css('top', (stopTop - boutonContainerTop - gap) + 'px');
            $boutonStickyMobile.fadeOut();
          } else {
            // On fixe quand on scrolle entre le haut et le stop
            $boutonSticky.addClass('affix');
            $boutonSticky.css('top', gap + 'px');
            $boutonStickyMobile.fadeIn();
          }
        } else {
          // On défixe quand on est au dessus du départ
          $boutonSticky.removeClass('affix');
          $boutonSticky.css('top', m + 'px');
          $boutonStickyMobile.fadeOut();
        }
      },


///Check the caracters entered in the Telephone field
//       phoneControl: function (selector) {
//
//         //Allow users to enter numbers only
//         $(selector).on('keypress', function (e) {
//           // console.log('key press');
//           var code = e.which || e.keyCode;
//           $(this).closest('form-group').removeClass('input-error');
//           // console.log( this.value +' // ' +this.value.length );
//           //caractère différent de backsuppr, tabulation, shift ou suppr
//           if (code !== 8 && code !== 9 && code !== 16 && code !== 46) {
//             // console.log(code);
//             if (this.value.length === 0 && (code !== 43 && code !== 48)) {
//               // console.log('1er caractère différent de + ou de 0, on laisse passer');
//               $(this).closest('form-group').addClass('input-error');
//               e.preventDefault();
//             }
//             else if (this.value.length === 1 && this.value == 0 && code == 56) {
//
//               // console.log('1er caractère = 0 et second caractère différent de 0, 6 ou 7');
//                $(this).closest('form-group').addClass('input-error');
//               e.preventDefault();
//             }
//             else if (code !== 43 && (code < 48 || code > 57)) {
//               // console.log('caractères autre que des chiffres');
//               $(this).closest('form-group').addClass('input-error');
//               e.preventDefault();
//             }
//           }
//         });

      setClassSliderMag: function () {
        if ($(window).width() > 768) {
          var post_slides_width = 0;
          $('.post .nav-rubriques').find('.slick-track .slick-slide').each( function( index, element ){
            post_slides_width += $(this).width();
          });
          if (post_slides_width < 794) {
            $('.post .nav-rubriques').find('.slick-track').addClass('slick-track-small');
          }

          var mag_slides_width = 0;
          $('.section-mag .nav-rubriques').find('.slick-track .slick-slide').each( function( index, element ){
            mag_slides_width += $(this).width();
          });
          if (mag_slides_width < 794) {
            $('.section-mag .nav-rubriques').find('.slick-track').addClass('slick-track-small');
          }
        }
      },

      // Affecte la position top au header à partir de la hauteur du bandeau cookie
      setTopHeader: function () {
        setTimeout(function(){
          if ($("#cookie-law-info-bar").is(":visible")) {
            // Si bandeau cookie visible...
            var height_navbar = $('.navbar-main').innerHeight();
            var height_cookies = $('#cookie-law-info-bar').innerHeight();
            var height_wpadminbar = $('#wpadminbar').innerHeight();
            
            if ($('#wpadminbar').is(":visible")) {
              $('#cookie-law-info-bar').css('top', '32px');
              $('header.navbar').css('top', height_cookies + height_wpadminbar - 2);
              $('.carousel').css('top', height_navbar + height_cookies);
              $('.section-wrapper').css('position', 'relative').css('top', height_navbar + height_cookies);
              $('footer').css('position', 'relative').css('top', height_navbar + height_cookies);

              if ($('body').hasClass('archive') || $('body').hasClass('recherche')) {
                var height_navbar_contact = $('.navbar-contact').innerHeight();
                $('.archive-header').css('position', 'relative').css('top', height_navbar + height_navbar_contact);
                $('.postlist').css('paddingTop', height_navbar + height_cookies);
              }

            } else {
              $('header.navbar').css('top', height_cookies);
              $('.carousel').css('top', height_navbar + height_cookies);
              $('.section-wrapper').css('position', 'relative').css('top', height_navbar + height_cookies);
              $('footer').css('position', 'relative').css('top', height_navbar + height_cookies);

              if ($('body').hasClass('archive') || $('body').hasClass('recherche')) {
                var height_navbar_contact = $('.navbar-contact').innerHeight();
                $('.archive-header').css('position', 'relative').css('top', height_navbar + height_navbar_contact);
                $('.postlist').css('paddingTop', height_navbar + height_cookies);
              }
            }
            

          } else {
            // Si on est sur la home...
            if ($('body').hasClass('home')) {
              var height_navbar = $('.navbar-main').innerHeight();
              if ($('#wpadminbar').is(":visible")) {

                var height_wpadminbar = $('#wpadminbar').innerHeight();
                $('header.navbar').css('top', height_wpadminbar - 2);
                $('.carousel').css('top', height_navbar);
                $('.section-wrapper').css('position', 'relative').css('top', height_navbar);
                $('footer').css('position', 'relative').css('top', height_navbar); 

              } else {
                
                // Décalage du carousel, des sections et du footer car la navbar est en position fixed
                $('.carousel').css('top', height_navbar);
                $('.section-wrapper').css('position', 'relative').css('top', height_navbar);
                $('footer').css('position', 'relative').css('top', height_navbar); 
              }             
            }
          }
        }, 400);
      },

      // Affecte la position top au header à partir de la hauteur du bandeau cookie lors du scroll
      setTopHeaderOnHideCookie: function () {
        setTimeout(function(){

          if ($('#wpadminbar').is(":visible")) {
            var height_navbar = $('.navbar-main').innerHeight();
            var height_wpadminbar = '62px';$('#wpadminbar').innerHeight();
            $('header.navbar').css('top', height_wpadminbar);
            $('.carousel').css('top', height_navbar);
            $('.section-wrapper').css('position', 'relative').css('top', height_navbar);
            $('footer').css('position', 'relative').css('top', height_navbar);

            if ($('body').hasClass('archive') || $('body').hasClass('recherche')) {
              var height_navbar_contact = $('.navbar-contact').innerHeight();
              var height_navbar = $('.navbar-main').innerHeight();
              $('.archive-header').css('position', 'relative').css('top', height_navbar_contact);
              $('.postlist').css('paddingTop', height_navbar);
            }
          } else {
            var height_navbar = $('.navbar-main').innerHeight();
            // $('header.navbar').css('top', 0);
            $('header.navbar').css('top', '30px');
            $('.carousel').css('top', height_navbar);
            $('.section-wrapper').css('position', 'relative').css('top', height_navbar);
            $('footer').css('position', 'relative').css('top', height_navbar);

            if ($('body').hasClass('archive') || $('body').hasClass('recherche')) {
              var height_navbar_contact = $('.navbar-contact').innerHeight();
              var height_navbar = $('.navbar-main').innerHeight();
              $('.archive-header').css('position', 'relative').css('top', height_navbar_contact);
              $('.postlist').css('paddingTop', height_navbar);
            }
          }

        }, 400);
      },

      // Page article : calcul pour l'élément 'outside-container'
      setValOutsideContainer: function () {
        var windowWidth = $(window).width();
        var containerWidth = $('.entry-content').find('.container').first().width();
        var theContentWidth = $('.the-content').width();
        var leftPosition = (windowWidth - containerWidth) / 2;
        var leftPositionVal = '-' + leftPosition + 'px';
        var leftContentPosition = (windowWidth - theContentWidth) / 2;
        var leftContentPositionVal = '-' + leftContentPosition + 'px';
        var outsideElementWidth = containerWidth + leftPosition;
        
        if (windowWidth > 768) {
          $('.outside-container').css('width',outsideElementWidth).css({left: leftContentPositionVal});
          $('.outside-container.saviez-vous').css('paddingLeft',leftContentPosition - 175).css({left: leftPositionVal});    // 175 correspond à la largeur du bloc saviez-vous-left
          //$('.outside-container').find('td').first().css('paddingLeft',leftPosition);
          $('.outside-container').find('td').first().css('paddingLeft',leftContentPosition);
        } else {
          $('.outside-container').css('width',outsideElementWidth + 10).css({left: '-10px'});
        }
      },

      phoneControl: function (selector) {

        //Allow users to enter numbers only
        $(selector).on('focus', function (e) {
          $(this).parent().parent().removeClass('has-error');
        });


        //Allow users to enter numbers only
        $(selector).on('keypress', function (e) {
          var code = e.which || e.keyCode;
          //caractère différent de backsuppr, tabulation, shift ou suppr
          if (code !== 8 && code !== 9 && code !== 16 && code !== 46) {
            // console.log(code);
            if (code !== 43 && (code < 48 || code > 57)) {
              // console.log('caractères autre que des chiffres');
              $(this).parent().parent().addClass('has-error');
              e.preventDefault();
            }
          }
        });


        $(selector).on('blur', function (e) {
          var code = e.which || e.keyCode;
          //caractère différent de backsuppr, tabulation, shift ou suppr
             console.log(this.value.substr(0, 1) +' // ' +this.value );
            if (this.value.substr(0, 1) !== '0' &&  this.value.substr(0, 1) !== '+') {
               console.log('1er caractère différent de + ou de 0, on met rouge');
              $(this).parent().parent().addClass('has-error');
            }
            else if (this.value.substr(1, 1) === '8') {
               console.log('seoncad char à 8 on laisse pas passer');
              $(this).parent().parent().addClass('has-error');

            }
        });

        //Si la longueur dépasse 10 caractères pour un mobile français on tronque à 10 caractères
        $(selector).on("keyup", function (e) {
          if (this.value.length > 10 && (this.value.startsWith('06') || this.value.startsWith('07'))) {
            this.value = this.value.substring(0, 10);
          }
        });

        //Disable paste
        $(selector).on("paste", function (e) {
          e.preventDefault();
        });
      },


      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }

    },
    // Home page
    'home': {
      video_ratio: 640 / 360,
      currentVideo: null,
      $carrousel: null,

      resizeVideo: function (scope, carouselRatio) {

        if (carouselRatio >= Sage.home.video_ratio) {
          scope.style.width = Sage.home.$carousel.width() + 'px';
          var h = Sage.home.$carousel.width() / Sage.home.video_ratio;
          scope.style.height = h + 'px';
        } else {
          scope.style.height = Sage.home.$carousel.height() + 'px';
          var w = Sage.home.$carousel.height() * Sage.home.video_ratio;
          scope.style.width = w + 'px';
          var l = -(w - document.documentElement.clientWidth) / 2;
          scope.style.left = l + 'px';
        }
      },

      onCarouselSlide: function (e) {
        var el;
        if (e == null) {
          el = Sage.home.$carousel.find('.active')[0];
        } else {
          el = e.relatedTarget;
        }

        if (el.className.indexOf('hasVideo') !== -1) {

          var carousel_ratio = Sage.home.$carousel.width() / Sage.home.$carousel.height();
          Sage.home.currentVideo = el.getElementsByTagName('video')[0];
          Sage.home.resizeVideo(Sage.home.currentVideo, carousel_ratio);
          Sage.home.currentVideo.style.display = "block";
          Sage.home.currentVideo.volume = 0;
          Sage.home.$carousel.find('video').fadeIn();


          Sage.home.currentVideo.play();
          Sage.home.$carousel.carousel('pause');


          Sage.home.currentVideo.addEventListener('ended', function () {
            Sage.home.$carousel.carousel('cycle');
            Sage.home.$carousel.carousel('next');
          });


        } else {
          if (Sage.home.currentVideo != null) {
            Sage.home.$carousel.find('video').fadeOut();
            Sage.home.currentVideo.pause();
            Sage.home.currentVideo.removeEventListener('ended', function () {
            });
            Sage.home.currentVideo.currentTime = 0;
            Sage.home.currentVideo = null;
          }
        }
      },


      init: function () {

        Sage.home.$carousel = $('#carousel-homepage');
        Sage.home.$carousel.carousel({interval: 10000});
        Sage.common.hammertime = new Hammer(Sage.home.$carousel[0]);
        Sage.common.hammertime.on('swipe', function (ev) {
          if (ev.direction === 2) {
            Sage.home.$carousel.carousel('next');
          } else {
            Sage.home.$carousel.carousel('prev');
          }
        });

        if (app.settings.isMobile.iOS() == null) {
          Sage.home.$carousel.on('slide.bs.carousel', Sage.home.onCarouselSlide);
          $(document).resize(function () {
            Sage.home.onCarouselSlide(null);
          });
          $(document).trigger('resize');
        } else {
          $('#carousel_background_vid').remove();
        }

        if (!app.settings.isMobile.any()) {
          $.stellar({
            horizontalScrolling: false,
            verticalScrolling: true,
            responsive: true,
            parallaxBackgrounds: true
          });
        }

        
      },

      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    }, // offres
    'page_template_template_page_section': {

      init: function () {

        var $scrollSpyNav = $('#nav-scrollspy');
        var $scope = $('#spy-scope');
        var $body = $(document);
        var m = 100;

        if (app.settings.isMobile.iOS() == null) {
          $('.trigger-scrollspy').mouseenter(function () {
            $(this).parent().addClass('over');
          }).mouseleave(function () {
            $(this).parent().removeClass('over');
          });

          $scrollSpyNav.find('a').mouseenter(function () {
            $(this).parent().addClass('open');
          }).mouseleave(function () {
            $(this).parent().removeClass('open');
          });
        }

        var gap = app.settings.NAVAFFIX + m;


        $(window).on('scroll', function () {

          if ($scope.offset().top - $body.scrollTop() < gap && $scope.offset().top + $scope.height() - $body.scrollTop() - $scrollSpyNav.height() > gap * 3) {
            $scrollSpyNav.addClass('affix');
            $scrollSpyNav.css('top', gap + 'px');
          } else {
            $scrollSpyNav.removeClass('affix');
            // repostionne la nav
            var n = $scope.offset().top + $scope.height() - $body.scrollTop();
            if ($scope.offset().top - $body.scrollTop() > app.settings.NAVAFFIX + m) {
              $scrollSpyNav.css('top', '100px');
            } else {
              n = $scope.height() - $scrollSpyNav.height() - gap * 2;
              $scrollSpyNav.css('top', n + 'px');
            }
          }
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };


// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

// Load Events
  $(document).ready(UTIL.loadEvents);

})
(jQuery); // Fully reference jQuery after this point.


